export type ParamRow = {
  value: string;
};

type ParamTableProps = {
  resources: ParamRow[];
};

export const ParamTable = ({ resources }: ParamTableProps) => {
  return (
    <div aria-label="queryExports" className="space-y-2 p-4">
      {resources.map((resource) => {
        return (
          <div key={resource.value}>
            <span className="align-middle text-fgDecorative">{resource.value}</span>
          </div>
        );
      })}
    </div>
  );
};
